<template>
  <div class="tw-rounded tw-whitespace-nowrap tw-border tw-border-solid tw-h-7 tw-inline-flex tw-items-center tw-px-3 tw-text-sm tw-font-light" v-on="$listeners">
    <span>{{ label }}</span>
    <font-awesome-icon :icon="['far', 'times']" class="tw-ml-2.5 tw-cursor-pointer" @click="$emit('close')" v-if="closable" />
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    closable: {
      type: Boolean,
      default: false
    }
  }
}
</script>
